import React from "react";

function LoadingLogo({ size = "md", message = "" }) {
  const sizeClasses = {
    sm: {
      outer: "w-10 h-10",
      inner: "w-8 h-8",
      logo: "h-6 w-6",
      text: "text-sm",
    },
    md: {
      outer: "w-12 h-12",
      inner: "w-10 h-10",
      logo: "h-7 w-7",
      text: "text-base",
    },
    lg: {
      outer: "w-16 h-16",
      inner: "w-14 h-14",
      logo: "h-10 w-10",
      text: "text-lg",
    },
  };

  const classes = sizeClasses[size] || sizeClasses.md;

  return (
    <div className="flex flex-col items-center justify-center">
      <div
        className={`${classes.outer} bg-white rounded-2xl flex items-center justify-center shadow-md ring-1 ring-gray-100 animate-pulse`}
      >
        <div
          className={`${classes.inner} bg-gradient-to-br from-blue-50 to-purple-50 rounded-xl flex items-center justify-center`}
        >
          <img
            src="/logo.svg"
            alt="MediLens"
            className={`${classes.logo} animate-spin`}
          />
        </div>
      </div>
      {message && (
        <p className={`mt-4 ${classes.text} text-gray-600`}>{message}</p>
      )}
    </div>
  );
}

export default LoadingLogo;
